import { Component, OnInit } from '@angular/core';
import { ClientService } from 'src/app/shared/services/client.service';// adapte le chemin
import { Utils } from "src/app/shared/utils/utils"; // si tu utilises Utils.sweetAlert

@Component({
  selector: 'app-appointments-list',
  templateUrl: './appointments-list.component.html',
  styleUrls: ['./appointments-list.component.css']
})
export class AppointmentsListComponent implements OnInit {
  appointments: any[] = [];
  busy: any;

  constructor(private clientService: ClientService) {}

  ngOnInit(): void {
    this.loadAppointments();
  }

  loadAppointments() {
    this.busy = this.clientService.getAppointments().subscribe(data => {
      this.appointments = data;
    }, err => {
      Utils.sweetAlert('error', 'Erreur', 'Impossible de charger les rendez-vous');
    });
  }

  deleteAppointment(id: number) {
    if(confirm("Voulez-vous vraiment supprimer ce rendez-vous ?")) {
      this.busy = this.clientService.deleteAppointment(id).subscribe(() => {
        Utils.sweetAlert('success', 'Succès', 'Rendez-vous supprimé');
        this.loadAppointments();
      }, err => {
        Utils.sweetAlert('error', 'Erreur', 'Impossible de supprimer ce rendez-vous');
      });
    }
  }
}

